var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"pt-3",attrs:{"align-h":"center"}},[_c('b-card',{staticClass:"maxwidth",attrs:{"title":"Error","title-tag":"h2"}},[_c('b-button',{attrs:{"to":"/","variant":"primary"}},[_vm._v(" Back to Home ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }